<template>
  <vue-bottom-sheet
    v-if="resource && publishing"
    :id="resourceSheet"
    ref="myBottomSheet"
    max-width="100%"
    max-height="90%"
    :click-to-close="true"
    :is-full-screen="true"
    :rounded="true"
    :background-scrollable="true"
    @open="handleOpened"
    @close="handleClosed"
    style=""
  >
    <resource-blog
      v-if="resourceId === '2gQb0AzBnKoIzI85wtGH'"
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
    />
    <resource-flip-book
      v-else-if="resourceId === '44NJCwDlvhgqnbugSvYT'"
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
    />
    <resource-blog
      v-else-if="resourceId === '2gQb0AzBnKoIzI85wtGH'"
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
    />
    <resource-shop
      v-else-if="resourceId === '5OqocpQK5kZIZDpmSHEJ'"
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
      @refresh-publishing="handleRefreshPublishing"
    />
    <resource-registration
      v-else-if="resourceId === '6j5w3qeU77vMaTx3op2y'"
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
    />
    <resource-pages
      v-else-if="resourceId === 'CmelKpnvCQrmIJ5rpHm4'"
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
    />
    <resource-survey
      v-else-if="resourceId === 'jnYuOcxljbqTdfLLfhRf'"
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
    />
    <resource-game-promo
      v-else-if="resourceId === 'jnYuOcxljbqTdfLLfhRf1'"
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
    />
    <resource-simon-game
      v-else-if="resourceId === '0If8J3cuADWx9f4kLi5C'"
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
    />
    <resource-tic-tac-toe
      v-else-if="resourceId === 'dNkdnpcTrT9xxFwyIPi8'"
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
    />
    <resource-slider-game
      v-else-if="resourceId === '5CeNANdl7ACJEbyMZ1xy'"
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
    />
    <resource-phrase-game
      v-else-if="resourceId === 'lyKfxLnGf5IzqQ63nJgF'"
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
    />
    <resource-photo-album
      v-else-if="resourceId === '7tI4hj9lEcUQ7twIFaCh'"
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
    />
    <!--Ak9N2bYixeBhwceyleaN -->
    <resource-match-game
      v-else
      :resource="resource"
      :publishing="publishing"
      :isManagementMode="isManagementMode"
      @refresh-publishing="handleRefreshPublishing"
    />
  </vue-bottom-sheet>
</template>
<script>
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import ResourceMatchGame from "@/components/blockResources/resourceMatchGame";
import ResourceSimonGame from "@/components/blockResources/resourceSimonGame";
import ResourceTicTacToe from "@/components/blockResources/resourceTicTacToe";
import ResourceSliderGame from "@/components/blockResources/resourceSliderGame";
import ResourcePhraseGame from "@/components/blockResources/resourcePhraseGame";
import ResourcePhotoAlbum from "@/components/blockResources/resourcePhotoAlbum";
import ResourceShop from "@/components/blockResources/resourceShop";
import ResourcePages from "@/components/blockResources/resourcePages";
import ResourceGamePromo from "@/components/blockResources/resourceGamePromo";
import ResourceBlog from "@/components/blockResources/resourceBlog";
import ResourceFlipBook from "@/components/blockResources/resourceFlipBook";
import ResourceRegistration from "@/components/blockResources/resourceRegistration";
import ResourceSurvey from "@/components/blockResources/resourceSurvey";
import Vue from "vue";
export default {
  name: "BaseResourceBottomSheet",
  components: {
    VueBottomSheet,
    ResourceMatchGame,
    ResourceSimonGame,
    ResourceTicTacToe,
    ResourceSliderGame,
    ResourcePhraseGame,
    ResourcePhotoAlbum,
    ResourceGamePromo,
    ResourceBlog,
    ResourceFlipBook,
    ResourceShop,
    ResourcePages,
    ResourceRegistration,
    ResourceSurvey
  },
  props: {
    resource: {
      type: Object,
      required: false,
      default: () => {}
    },
    publishing: {
      type: Object,
      required: false,
      default: () => {}
    },
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    isManagementMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      resourceSheet: "resource-sheet",
      title:
        this.resource && this.resource.name
          ? this.resource.name
          : "Not A Available",
      imgURL: this.resource && this.resource.imgURL ? this.resource.imgURL : "",
      faIcon:
        this.resource && this.resource.icon ? this.resource.icon : "fa-folder"
    };
  },
  computed: {
    resourceId() {
      return this.resource && this.resource.toolId
        ? this.resource.toolId
        : null;
    }
  },
  methods: {
    handleRefreshPublishing() {
      console.log("refreshing publishing- base");
      this.$emit("refresh-publishing");
    },
    open(resource, corner) {
      this.$refs.myBottomSheet.open();
    },
    hideResource() {
      // console.log("Hiding here");
      this.$refs.myBottomSheet.close();
    },
    handleOpened() {
      //console.log("has been opened");
    },
    handleClosed() {
      console.log("has been closed-clear it all");
    },
    handleSubmit() {}
  },
  mounted() {
    //bottomSheet:<div class="bottom-sheet closed">
    //bottomSheetCard:<div class="bottom-sheet__card square fx-default">
    // bottomSheetCardContent:<div class="bottom-sheet__content">
    // pan:<div
    console.log(`basedResourceBottomSheet Store is  ${this.$store}`);
  }
};
</script>

<style lang="scss"></style>
